var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeneficiaryAccountWithBlueCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9361",
    "data-name": "Group 9361",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5148",
    "data-name": "Rectangle 5148",
    width: 107,
    height: 107,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9334",
    "data-name": "Group 9334",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6342",
    "data-name": "Path 6342",
    d: "M107,53.5A53.5,53.5,0,1,1,53.5,0,53.5,53.5,0,0,1,107,53.5",
    transform: "translate(0 -0.001)",
    fill: "#1b3d6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6343",
    "data-name": "Path 6343",
    d: "M109.434,67.7c7.249,5.061,17.222,10.65,38.878,26.1.506.505-.111,37.506-37.6,50.168a380.824,380.824,0,0,1-39.305-33.5",
    transform: "translate(-41.395 -39.247)",
    fill: "#092246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6344",
    "data-name": "Path 6344",
    d: "M116.313,87.353a28.96,28.96,0,1,1-28.96-28.96,28.96,28.96,0,0,1,28.96,28.96",
    transform: "translate(-33.853 -33.853)",
    fill: "#4aa05c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_768",
    "data-name": "Ellipse 768",
    cx: 28.96,
    cy: 28.96,
    r: 28.96,
    transform: "translate(24.539 24.54)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6345",
    "data-name": "Path 6345",
    d: "M89.572,130.441a20.066,20.066,0,0,0-6.752,1.352c-1.85.74-4.05,2.044-4.05,4.047v2.7h21.6v-2.7a3.2,3.2,0,0,0-1.181-2.359,9.365,9.365,0,0,0-2.868-1.689,20.067,20.067,0,0,0-6.755-1.351Z",
    transform: "translate(-45.667 -75.623)",
    fill: "#f8ca8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6346",
    "data-name": "Path 6346",
    d: "M89.572,130.441a17.314,17.314,0,0,0-6.752,1.609c-1.85.881-4.05,2.432-4.05,4.817v3.213h21.6v-3.213a4.1,4.1,0,0,0-1.181-2.808,9.177,9.177,0,0,0-2.868-2.01,17.314,17.314,0,0,0-6.755-1.608Z",
    transform: "translate(-45.667 -77.55)",
    fill: "#2d683a",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6347",
    "data-name": "Path 6347",
    d: "M97.021,98.31a5.4,5.4,0,1,0,5.4,5.4,5.4,5.4,0,0,0-5.4-5.4Z",
    transform: "translate(-53.116 -56.995)",
    fill: "#fc982e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6348",
    "data-name": "Path 6348",
    d: "M97.021,98.31a5.4,5.4,0,1,0,5.4,5.4,5.4,5.4,0,0,0-5.4-5.4Z",
    transform: "translate(-53.116 -56.995)",
    fill: "#2d683a",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6349",
    "data-name": "Path 6349",
    d: "M135.229,130.433a20.07,20.07,0,0,0-6.752,1.352c-1.85.74-4.049,2.044-4.049,4.047v2.7h21.6v-2.7a3.2,3.2,0,0,0-1.181-2.359,9.368,9.368,0,0,0-2.868-1.689,20.066,20.066,0,0,0-6.755-1.351Z",
    transform: "translate(-72.137 -75.618)",
    fill: "#f8ca8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6350",
    "data-name": "Path 6350",
    d: "M135.229,130.433a17.317,17.317,0,0,0-6.752,1.609c-1.85.881-4.049,2.432-4.049,4.817v3.213h21.6v-3.213a4.1,4.1,0,0,0-1.181-2.808,9.18,9.18,0,0,0-2.868-2.01,17.313,17.313,0,0,0-6.755-1.608Z",
    transform: "translate(-72.137 -77.545)",
    fill: "#2d683a",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6351",
    "data-name": "Path 6351",
    d: "M142.677,98.3a5.4,5.4,0,1,0,5.4,5.4,5.4,5.4,0,0,0-5.4-5.4Z",
    transform: "translate(-79.585 -56.99)",
    fill: "#f8ca8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6352",
    "data-name": "Path 6352",
    d: "M142.677,98.3a5.4,5.4,0,1,0,5.4,5.4,5.4,5.4,0,0,0-5.4-5.4Z",
    transform: "translate(-79.585 -56.99)",
    fill: "#2d683a",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6353",
    "data-name": "Path 6353",
    d: "M107.51,130.649a24.88,24.88,0,0,0-8.37,1.676c-2.293.918-5.02,2.534-5.02,5.017v3.347H120.9v-3.347a3.97,3.97,0,0,0-1.464-2.924,11.6,11.6,0,0,0-3.556-2.094,24.88,24.88,0,0,0-8.374-1.675Z",
    transform: "translate(-54.566 -75.743)",
    fill: "#f8ca8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6354",
    "data-name": "Path 6354",
    d: "M107.51,130.649a21.467,21.467,0,0,0-8.37,1.995c-2.293,1.093-5.02,3.016-5.02,5.972V142.6H120.9v-3.984a5.085,5.085,0,0,0-1.464-3.48,11.367,11.367,0,0,0-3.556-2.492,21.466,21.466,0,0,0-8.374-1.994Z",
    transform: "translate(-54.565 -77.653)",
    fill: "#698552",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6355",
    "data-name": "Path 6355",
    d: "M116.743,90.816a6.7,6.7,0,1,0,6.7,6.7,6.7,6.7,0,0,0-6.7-6.7Z",
    transform: "translate(-63.799 -52.65)",
    fill: "#f8ca8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6356",
    "data-name": "Path 6356",
    d: "M116.743,90.816a6.7,6.7,0,1,0,6.7,6.7,6.7,6.7,0,0,0-6.7-6.7Z",
    transform: "translate(-63.799 -52.65)",
    fill: "#698552",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeneficiaryAccountWithBlueCircle);
export default __webpack_public_path__ + "static/media/beneficiary_account_with_blue_circle.ef6e7315898b8d5935c77eccf0f93bdf.svg";
export { ForwardRef as ReactComponent };